import { useQuery } from '@tanstack/react-query';
import React from 'react';

import { fetchKybProcesses } from 'apis/legitimizer/kyb/api';
import { fetchMerchants } from 'apis/restaurant-api/merchant-admin/merchant/api';
import Loading from 'core/Loading';

import KycSuccessLoading from './KycSuccessLoading';
import KycSuccessThanks from './KycSuccessThanks';
import * as api from '../../../apis/merchant-onboarding-service/api';
import Contracts from '../../merchant-sign-up/Contracts/Contracts';

const KycSuccess = () => {
  const {
    data: userContracts,
    isLoading: isLoadingContracts,
    error: contractsError,
  } = useQuery(['/me/contracts'], () => api.getUserContractDetails(), {
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    retry: false,
  });

  const { data: merchants, error: merchantsError } = useQuery(
    ['/v1/merchant-admin/merchants'],
    () => fetchMerchants(),
    {
      enabled: userContracts?.length === 0,
      refetchOnMount: true,
      refetchOnWindowFocus: true,
      retry: false,
      refetchInterval: 10000,
    },
  );

  const merchantIds = merchants?.map(m => m.itemid.$oid);

  const { data: kybProcesses, error: kybProcessesError } = useQuery(
    ['/v1/kyb/merchants/processes/latest', merchantIds],
    () => (merchantIds ? fetchKybProcesses(merchantIds) : undefined),
    {
      enabled: !!merchantIds,
      refetchInterval: 10000,
    },
  );

  const error = contractsError || merchantsError || kybProcessesError;

  // First, wait until contracts are loaded
  if (isLoadingContracts) {
    return <Loading />;
  }

  // Contractful flow, there are open contracts pending (majority of the cases)
  if (userContracts?.length !== 0) {
    return <Contracts />;
  }

  // No contracts, but some Merchant and some KYB process already exists
  // Redirect to Thanks page -> Landing page
  if (kybProcesses?.length !== 0 || !!error) {
    return <KycSuccessThanks />;
  }

  // If no KYB processes found, it means:
  // [Contractless flow] AND [Merchant + KYB process haven't been created yet]
  // Wait until that happens before redirecting to Thanks page -> Landing page
  return <KycSuccessLoading />;
};

export default KycSuccess;
